// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"93538b50","732":"bb1b93ed","977":"dcb5c5b6"}[chunkId] + ".chunk.js";
};